export const RESERVATIONS_CONSTS = {
    GET_RESERVATIONS: "GET_RESERVATIONS",
    UPDATE_RESERVATION: "UPDATE_RESERVATION",
    DELETE_RESERVATION_BY_ID: "DELETE_RESERVATION_BY_ID",

    GET_CALL_STATEMENT: "GET_CALL_STATEMENT",
    DELETE_CALL_STATEMENT_BY_ID: "DELETE_CALL_STATEMENT_BY_ID",
};
